export default __webpack_public_path__ + "static/ranklists-success-a60ca2a5ffe7b4fbc8390e403ae46c0d.gif";